<a [class]="cssClass" [href]="url" [target]="target">
  {{ text ? text : url }}
  <svg *ngIf="showIcon" class="icon-svg link">
    <use xlink:href="#menu-up"></use>
  </svg>
</a>
